// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  box-sizing: border-box;
  padding: 0;
  font-family:
    "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans",
    Arial, sans-serif;
}

body {
  background-color: #ffffff;
  display: grid;
  grid-template-rows: 10vh auto 25vh;
  row-gap: calc(10vh / 3);
  min-height: 100vh;
  margin: 0 auto;
}

/* Search Bar */

#search {
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  padding: 0px 24px;
  margin: 0px 48px;
  border-bottom: solid 2px black;
}

input {
  border: none;
  flex-basis: 70%;
  font-size: clamp(1em, 2.5em, 2.5em);
}

input:focus {
  outline: none;
}

#search > button {
  background-color: #fff;
  border: none;
}

/* Daily View */

#daily-view {
  margin: 0 16px;
  padding: 16px;
  width: 60%;
  margin: 0 auto;
  display: grid;
  grid-template-rows: auto auto auto auto;
  height: fit-content;
  row-gap: 12px;
  height: 100%;
  border: 8px solid var(--main-color);
  border-radius: 20px;
  background-color: #fff;
}

#daily-date {
  font-size: 5rem;
}

#daily-desc {
  font-size: 3rem;
}

#daily-temp {
  display: flex;
  gap: 8px;
}

#avg-temp {
  font-size: 3rem;
}

#temp-minmax {
  display: flex;
  gap: 4px;
  flex-direction: column;
  font-size: 1.2rem;
}

#daily-details {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 2rem;
}

/* Weekly View */

#weekly-view {
  display: flex;
  justify-content: space-around;
  gap: 12px;
  padding: 12px;
}

#weekly-view button {
  padding: 12px;
  flex: 1;
}

.day-card {
  background-color: #fff;
  border-radius: 12px;
  border: 4px solid var(--main-color);
}
.day-card:hover,
.day-card.selected {
  background-color: var(--main-color);
}
/* AI advised use of custom css properties when I asked for feedback */
.snow {
  --main-color: #a8d8ea;
}
.rain {
  --main-color: #4dabf7;
}
.fog {
  --main-color: #595f66;
}
.wind {
  --main-color: #845ef7;
}
.cloudy {
  --main-color: #868e96;
}
.clear {
  --main-color: #ffd43b;
}
.partly-cloudy {
  --main-color: #ced4da;
}

.day-preview {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
}
.date-preview {
  font-size: 2.5rem;
}
.temp-preview {
  font-size: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV;;qBAEmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,eAAe;;AAEf;EACE,cAAc;EACd,aAAa;EACb,UAAU;EACV,cAAc;EACd,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;AACrC;AACA;;EAEE,mCAAmC;AACrC;AACA,sEAAsE;AACtE;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB","sourcesContent":["* {\n  margin: 0;\n  box-sizing: border-box;\n  padding: 0;\n  font-family:\n    \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\", \"Lucida Sans\",\n    Arial, sans-serif;\n}\n\nbody {\n  background-color: #ffffff;\n  display: grid;\n  grid-template-rows: 10vh auto 25vh;\n  row-gap: calc(10vh / 3);\n  min-height: 100vh;\n  margin: 0 auto;\n}\n\n/* Search Bar */\n\n#search {\n  display: flex;\n  background-color: #fff;\n  justify-content: space-between;\n  padding: 0px 24px;\n  margin: 0px 48px;\n  border-bottom: solid 2px black;\n}\n\ninput {\n  border: none;\n  flex-basis: 70%;\n  font-size: clamp(1em, 2.5em, 2.5em);\n}\n\ninput:focus {\n  outline: none;\n}\n\n#search > button {\n  background-color: #fff;\n  border: none;\n}\n\n/* Daily View */\n\n#daily-view {\n  margin: 0 16px;\n  padding: 16px;\n  width: 60%;\n  margin: 0 auto;\n  display: grid;\n  grid-template-rows: auto auto auto auto;\n  height: fit-content;\n  row-gap: 12px;\n  height: 100%;\n  border: 8px solid var(--main-color);\n  border-radius: 20px;\n  background-color: #fff;\n}\n\n#daily-date {\n  font-size: 5rem;\n}\n\n#daily-desc {\n  font-size: 3rem;\n}\n\n#daily-temp {\n  display: flex;\n  gap: 8px;\n}\n\n#avg-temp {\n  font-size: 3rem;\n}\n\n#temp-minmax {\n  display: flex;\n  gap: 4px;\n  flex-direction: column;\n  font-size: 1.2rem;\n}\n\n#daily-details {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-size: 2rem;\n}\n\n/* Weekly View */\n\n#weekly-view {\n  display: flex;\n  justify-content: space-around;\n  gap: 12px;\n  padding: 12px;\n}\n\n#weekly-view button {\n  padding: 12px;\n  flex: 1;\n}\n\n.day-card {\n  background-color: #fff;\n  border-radius: 12px;\n  border: 4px solid var(--main-color);\n}\n.day-card:hover,\n.day-card.selected {\n  background-color: var(--main-color);\n}\n/* AI advised use of custom css properties when I asked for feedback */\n.snow {\n  --main-color: #a8d8ea;\n}\n.rain {\n  --main-color: #4dabf7;\n}\n.fog {\n  --main-color: #595f66;\n}\n.wind {\n  --main-color: #845ef7;\n}\n.cloudy {\n  --main-color: #868e96;\n}\n.clear {\n  --main-color: #ffd43b;\n}\n.partly-cloudy {\n  --main-color: #ced4da;\n}\n\n.day-preview {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  height: 100%;\n}\n.date-preview {\n  font-size: 2.5rem;\n}\n.temp-preview {\n  font-size: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
